import React from 'react';
import classNames from 'classnames';

export interface IWFNXSmallCardFooterProps {
  children?: React.ReactNode;
  className?: string;
}

export class WFNXSmallCardFooter extends React.Component<IWFNXSmallCardFooterProps, any> {
  render() {
    const { className } = this.props;

    return (
      <div className={classNames('wfnx-small-card-footer', className)}>
        {this.props.children}
      </div>
    );
  }
}
